export default __webpack_public_path__ + "static/media/logo.404c7dac.png";